import { handleActions } from 'redux-actions'

export const defaultState = {
  exportOptions: {
    withWholesale: false,
    withWholesaleFactor: false,
    withDiscounts: false,
    withRetail: false,
    withMarkup: false,
    withRetailFactor: false,
    withBudget: false,
    withComments: false,
    withTags: false,
    withUnits: false,
    withCurrencyConversion: false,
    withCurrencyConversionId: '',
  },
  submittingExcelExport: false,
}

const reducer = handleActions(
  {
    'BRAND_EXCEL_EXPORT_MODAL/SET_EXPORT_OPTIONS': (state, { payload }) => ({
      ...state,
      exportOptions: payload,
    }),
    'BRAND_EXCEL_EXPORT_MODAL/BEGIN_SUBMIT': (state) => ({
      ...state,
      submittingExcelExport: true,
    }),
    'BRAND_EXCEL_EXPORT_MODAL/END_SUBMIT': (state) => ({
      ...state,
      submittingExcelExport: false,
    }),
  },
  defaultState,
)

export default reducer
